import { createUseStyles } from 'react-jss';

import { FontWeight, ITheme, mediaQuery } from '../../../../styles';

const useStyles = createUseStyles(
  ({ breakpoints }: ITheme) => ({
    modalText: {
      fontSize: 20,
      fontWeight: 700,
    },
    toolName: {
      display: 'block',
      marginTop: 24,
      fontSize: 14,
      fontWeight: FontWeight.Bold,
      color: 'var(--x-text-color-2)',
    },
    toolUrl: {
      display: 'block',
      marginTop: 4,
      fontSize: 14,
      fontWeight: FontWeight.SemiBold,
      color: 'var(--x-textf-field-color-1)',
    },
    toolsContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: 16,
      marginTop: 16,
      maxWidth: 384,
      [mediaQuery(breakpoints.mobile)]: {
        gap: 6,
      },
    },
    shareMethodName: {
      display: 'block',
      textAlign: 'center',
      fontSize: 12,
      color: 'var(--x-textf-field-color-1)',
      marginTop: 8,
    },
    shareMethodContainer: {
      padding: [0, 14],
      [mediaQuery(breakpoints.mobile)]: {
        padding: [0, 10],
      },
    },
  }),
  {
    name: 'share-modal',
  },
);

export default useStyles;
